export const ZoomValueType = {
	auto: 'auto',
	pageActual: 'page-actual',
	pageFit: 'page-fit',
	pageWidth: 'page-width',
} as const;
export type ZoomValueType = (typeof ZoomValueType)[keyof typeof ZoomValueType] | number;
